/**
 * Labstep
 *
 * @module components/Organization/Analytics
 * @desc Organization analytics dashboard
 */

import { OrganizationAnalyticsChart as Chart } from 'labstep-web/components/Organization/Analytics/Chart';
import { OrganizationAnalyticsIntervalToggle } from 'labstep-web/components/Organization/Analytics/IntervalToggle';
import {
  ORGANIZATION_ANALYTICS_INTERVAL,
  ORGANIZATION_ANALYTICS_METRICS,
} from 'labstep-web/constants/analytics';
import React from 'react';
import { Container, Divider, Grid, Header } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { OrganizationAnalyticsProps } from './types';

export const OrganizationAnalytics: React.FC<
  OrganizationAnalyticsProps
> = () => {
  const [interval, setInterval] =
    React.useState<ORGANIZATION_ANALYTICS_INTERVAL>(
      ORGANIZATION_ANALYTICS_INTERVAL.monthly,
    );

  return (
    <Container fluid className={styles.container}>
      <div className={styles.dashboardHeader}>
        <Header as="h2" className={styles.pageTitle}>
          Analytics Dashboard
        </Header>
        <p className={styles.pageSubtitle}>
          View insights on how your organization is using Labstep
        </p>
      </div>

      <Divider />

      <OrganizationAnalyticsIntervalToggle
        interval={interval}
        setInterval={setInterval}
      />

      <Grid stackable columns={2} className={styles.metricsGrid}>
        <Grid.Row>
          <Grid.Column>
            {ORGANIZATION_ANALYTICS_METRICS.map((metric) => (
              <Chart
                key={`${interval}_${metric}`}
                title={metric.replace(/_/g, ' ').toUpperCase()}
                interval={interval}
                metric={metric}
              />
            ))}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};
